import firebase from "firebase/compat/app"
import 'firebase/compat/auth'
import 'firebase/compat/storage'
import "firebase/compat/firestore";
import { getFirestore, connectFirestoreEmulator } from "@firebase/firestore"
import { getAuth, initializeAuth, indexedDBLocalPersistence } from 'firebase/auth'
import { getMessaging, isSupported as isMessagingSupported, getToken, onMessage } from "firebase/messaging";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { useLocation } from "react-router-dom";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}

const app = firebase.initializeApp(firebaseConfig);
// Create function instances for different regions
// Most functions use us-east1, but some use us-central1
const functions = getFunctions(app) // Default (us-central1) for backward compatibility
const functionsUsEast1 = getFunctions(app, 'us-east1') // For EOS functions
const db = getFirestore(app)
/* 
if(window.location.hostname === 'localhost'){
  connectFirestoreEmulator(db, 'localhost', 8080);
}   */
 
const auth = getAuth(app);

// Firebase Cloud Messaging is NOT supported in every browser the Hub runs in:
// iOS in-app webviews (Gmail/Outlook/Teams/Slack link opens), Safari Private
// Browsing, and Lockdown Mode have no navigator.serviceWorker, and
// getMessaging() touches navigator.serviceWorker.addEventListener
// SYNCHRONOUSLY. Calling it unguarded at module scope crashed the entire
// bundle before React could mount — a permanent white screen in those
// environments.
//
// On top of the synchronous crash, getMessaging() ALSO kicks off an internal
// isWindowSupported() probe and throws `messaging/indexed-db-unsupported`
// inside its own promise chain when indexedDB can't open (Safari Private,
// Safari iframes) — an unhandled rejection no try/catch around getMessaging
// can intercept. So getMessaging() is only called AFTER firebase's own
// isSupported() resolves true. `messaging` stays null (and `messagingReady`
// resolves null) wherever push isn't supported; every consumer no-ops.
let messaging = null;
const messagingReady = (() => {
  try {
    if (
      typeof navigator !== 'undefined' &&
      'serviceWorker' in navigator &&
      navigator.serviceWorker && // guard against present-but-undefined
      typeof window !== 'undefined' &&
      'Notification' in window &&
      'PushManager' in window
    ) {
      return isMessagingSupported()
        .then((supported) => {
          if (!supported) return null;
          messaging = getMessaging(app);
          return messaging;
        })
        .catch((err) => {
          console.warn('FCM unavailable in this browser:', err);
          return null;
        });
    }
  } catch (err) {
    console.warn('FCM unavailable in this browser:', err);
  }
  return Promise.resolve(null);
})();

// Analytics is similarly guarded: never let an unsupported environment
// (cookies/indexedDB restrictions) take down the whole bundle at import time.
let analytics = null;
try {
  analytics = getAnalytics(app);
} catch (err) {
  console.warn('Analytics unavailable in this browser:', err);
  analytics = null;
}

export { app, db, firebase, auth, messaging, messagingReady, firebaseConfig, functions, functionsUsEast1, analytics };

export const requestForToken = async (setCurrentToken) => {
  const m = await messagingReady;
  if (!m) return; // push unsupported in this browser — no-op
  return getToken(m, { vapidKey: process.env.REACT_APP_VAPID_KEY })
    .then((currentToken) => {
      if (currentToken) {
        //console.log('current token for client: ', currentToken);
        setCurrentToken(currentToken)
      } else {
        // Show permission request UI
        //console.log('No registration token available. Request permission to generate one.');
      }
    })
    .catch((err) => {
      //console.log('An error occurred while retrieving token. ', err);
    });
};


export const onMessageListener = () =>
  new Promise((resolve) => {
    // When push is unsupported the promise simply never resolves — the same
    // observable behavior as "no message ever arrives" for consumers.
    messagingReady.then((m) => {
      if (!m) return;
      onMessage(m, (payload) => {
        //console.log("payload", payload)
        resolve(payload);
      });
    });
  });

  